interface Props {
  onStart: () => void;
  working: boolean;
  disabled?: boolean;
  label?: string;
}

export function StartSessionButton({ onStart, working, disabled, label }: Props) {
  return (
    <button
      type="button"
      className="btn-primary w-full justify-center !py-2 text-sm"
      onClick={onStart}
      disabled={working || disabled}
    >
      {working ? 'Starting…' : (label ?? 'Start session ▶')}
    </button>
  );
}
